import type { LabelHTMLAttributes } from 'react'

import { cn } from '../../lib/cn'

/** Etiqueta shadcn-style — empareja con Input vía `htmlFor` / `id`. */
export function Label({ className, ...props }: LabelHTMLAttributes<HTMLLabelElement>) {
    return (
        <label
            className={cn('text-xs font-medium text-neutral-400', className)}
            {...props}
        />
    )
}
